module.exports = __webpack_public_path__ + "static/media/Fish Games-banner.dce3ace2.png";